<template>
  <div id="root-common-header">
    <satisfaction-survey v-if="isShowSurvey" :satisfactionSurveyInfo="satisfactionSurveyInfo" />
  </div>
</template>
<script>
import satisfactionSurvey from 'Src/components/satisfaction-survey/index.vue'
// import Apis from 'Src/const/apis.js'
// import { accountRole } from 'Src/const/state/account'
import { safetyGet } from 'Src/util/tool'
import { loginType } from 'Src/const/state/ad'
import { catchableParse } from 'Src/util/json'
import { isBp } from 'Src/util/tool.js'

let hasUpdateBPNavigator = !!window.BusinessNavigator


function navConfig (that, window) {
  let defaultNavConfig = {
    render_to: '#root-common-header',
    logo_href: that.globalUpdateQuery('/pages/index.html'),
    eventListener: (eventName, params) => {
      window.teaEvent('common_header_click', {
        event_name: eventName,
        event_info: JSON.stringify(params),
        advertiser_id: safetyGet(that.globalVar, 'advertiser.id', ''),
        customer_type: safetyGet(that.globalVar, 'customerType', ''),
        company_id: safetyGet(that.globalVar, 'campaignId', ''),
        first_industry_name: safetyGet(that.globalVar, 'advertiser.first_industry_id_v3', ''),
        second_industry_name: safetyGet(that.globalVar, 'advertiser.second_industry_id_v3', ''),
        advertiser_role: safetyGet(that.globalVar, 'advertiser.role', ''),
        current_url: window.location.href,
        login_way: (() => {
          switch (true) {
            // 账户密码登录
            case catchableParse(safetyGet(that.globalVar, 'isAdmin')):
              return loginType.isAdmin
            // 内部系统附身: 内部优化师
            case catchableParse(safetyGet(that.globalVar, 'sales')):
              return loginType.isStaff
            // 外部系统附身: 代理商 + 账户管家附身
            case catchableParse(safetyGet(that.globalVar, 'user_jobbed')):
              return loginType.isCoreUser
            default:
              return ''
          }
        })()
      })
    },
    extra_style_func: () => { // 额外样式渲染 一级菜单二级菜单重叠不明显 为了区分二级菜单加一些阴影
      return `.CSS_NAMESPACE-link-tips{
          background-color:#F5F5F5;
        }`.trim()
    }
  }
  return !isBp() ? defaultNavConfig : {}
}

export default {
  name: 'nav-header',
  components: {
    satisfactionSurvey
  },
  data: function () {
    return {
      // advertiser: GLOBAL_VAR.advertiser,
      // advertiserAgent: GLOBAL_VAR.advertiserAgent,
      // agent: GLOBAL_VAR.agent,
      // coreUser: GLOBAL_VAR.coreUser,
      // backToAdmin: JSON.parse(GLOBAL_VAR.permissions.backToAdmin),
      // backToAgent: JSON.parse(GLOBAL_VAR.permissions.backToAgent),
      // backToMajordomo: JSON.parse(GLOBAL_VAR.permissions.backToMajordomo),
      satisfactionSurveyInfo: {
        exist: true
      },
      globalVar: safetyGet(window, 'GLOBAL_VAR', {})
    }
  },
  computed: {
    // isShowAdminAgent: function () {
    //   // 管理员访问代理商，代理商访问普通广告主
    //   return this.backToAdmin && this.backToAgent;
    // },
    // isShowAgent: function () {
    //   // 代理商访问普通广告主
    //   return !this.backToAdmin && this.backToAgent;
    // },
    // isLogin: function () {
    //   return !!this.coreUser.adminName;
    // },
    isShowSurvey: function () {
      // 目前只针对管理员和一般广告主开放满意度调研
      // *******只需要修改此处以及打开mounted中的判断，即可继续使用满意度调研******
      // return !this.satisfactionSurveyInfo.exist
      return false
    }
  },
  methods: {
    // getSatisfactionSurveyInfo () {
    //   BUI.fetch({
    //     url: Apis.satisfactionSurvey,
    //     success: (resp) => {
    //       this.satisfactionSurveyInfo = {
    //         key: resp.data.key,
    //         exist: resp.data.exist
    //       }
    //     }
    //   })
    // }
  },
  mounted () {
    if(!isBp() || !hasUpdateBPNavigator){
      this.$nextTick(() => {
        if (window.headerInstance && window.headerInstance.methods && window.headerInstance.methods.hasOwnProperty('initOnload')) {
          window.headerInstance.methods.initOnload({
            render_to: '#root-common-header',
            logo_href: this.globalUpdateQuery('/pages/index.html'),
            container: {
              style: {
                'min-width': '1200px'
              }
            }
          })
        } else if (window.navigatorInstance && window.navigatorInstance.methods && window.navigatorInstance.methods.hasOwnProperty('initHeader')) {
          window.navigatorInstance.methods.initHeader(navConfig(this, window))
        }
      })
    }
  }
}
</script>
<style lang="scss">
  @import "../../basic/theme.scss";
  #root-common-header {
    height: 64px;
    // background: #0A2140;
  }
  .icon-large {
    width: 25px;
    height: 25px;
    line-height: 25px;
  }

  .nav-header-panel {
    height: 65px;
    width: 100%;
    .header-container {
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
      -webkit-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      align-items: center;
      width: 100%;
      height: 100%;
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
      background-color: #ff635c;
      color: #fff;
    }
    a {
      color: #fff !important;
      text-decoration: none !important;
    }
    .logo {
      img {
        width: 100px;
        display: inline-block;
        position: relative;
        bottom: 3px;
      }
      .logo-text {
        padding-left: 10px;
        font-size: 22px;
        bottom: -3px;
        position: relative;
        display: inline-block;
      }
    }
    .user-info {
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
      -webkit-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      align-items: center;
      height: 65px;
      position: absolute;
      right: 15px;
      top: 0;
      & > span:nth-of-type(1) {
        border-left: none;
      }
      & > span {
        border-left: 1px dotted #ffffff;
        padding: 0 10px;
      }
      .advertiser-cell {
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        -o-align-items: center;
        align-items: center;
        height: 20px;
        &-name {
          display: inline-block;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          max-width: 220px;
        }
      }
      .account {
        display: -webkit-inline-flex;
        display: -moz-inline-flex;
        display: -ms-inline-flex;
        display: -o-inline-flex;
        display: inline-flex;
        -webkit-flex-direction: column;
        -moz-flex-direction: column;
        -ms-flex-direction: column;
        -o-flex-direction: column;
        flex-direction: column;
        border: none;
        span:first-child {
          position: relative;
        }
        span:last-child {
          position: relative;
          font-size: 13px;
        }
        &-label {
          text-align: right;
        }
      }
      .agent-cell {
        height: 20px;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        -o-align-items: center;
        align-items: center;
        .back-to-agent {
          display: -webkit-inline-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          max-width: 100px;
          overflow: hidden;
        }
      }
    }
  }
  .nav-header-login-container {
    padding-right: 32px;
  }

  .contract-container-top {
    .title-child-p.highlight {
      color: #2A55E5 !important;
      background-color: #fff !important;
      border-radius: 8px !important;
      font-weight: 600 !important;
    }

    .title-con-span span {
      display: flex;
    }
  }

</style>
